import React, { useState, useLayoutEffect, useEffect, useContext } from 'react';
import { Button, IconButton, Snackbar } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useLocation } from 'react-router-dom';
import { I18nContext } from 'translations';
import { useStateValue } from 'context/store';
import { message as clearMessage } from 'context/commons/actions';
import { getLastErrorData, triggerErrorReportModal } from 'utils/errorReporter';

const FIVE_MINUTES = 300000;

function GlobalSnackbar() {
  const { translate } = useContext(I18nContext);
  const [{ commons: { message } }, dispatch] = useStateValue();
  const location = useLocation();
  const [localMessage, setLocalMessage] = useState(null);
  const [hasError, setHasError] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useLayoutEffect(() => {
    if (message) {
      setLocalMessage(message);
      setHasError(!!getLastErrorData());
      setOpen(true);
      clearMessage(dispatch, null);
    }
  }, [message, dispatch]);

  const handleClose = (_, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };

  const handleReport = () => {
    setOpen(false);
    triggerErrorReportModal();
  };

  return (
    <Snackbar
      style={{ zIndex: 99999 }}
      open={open}
      autoHideDuration={FIVE_MINUTES}
      onClose={handleClose}
    >
      <div
        style={{
          backgroundColor: '#323232',
          color: '#fff',
          borderRadius: 4,
          padding: '8px 8px 8px 16px',
          display: 'flex',
          alignItems: 'flex-start',
          minWidth: 288,
          maxWidth: 568,
          boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14)',
        }}
      >
        <span
          style={{
            flex: 1,
            fontSize: '0.875rem',
            lineHeight: '1.43',
            padding: '8px 0',
          }}
        >
          {localMessage ? translate(localMessage) : ''}
        </span>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            alignSelf: 'stretch',
            paddingLeft: 12,
            flexShrink: 0,
          }}
        >
          <IconButton size="small" color="inherit" onClick={() => setOpen(false)} style={{ position: 'relative', top: '-7px', right: '-3px' }}>
            <CloseIcon fontSize="small" />
          </IconButton>
          {hasError && (
            <Button
              size="small"
              variant="outlined"
              onClick={handleReport}
              style={{
                color: '#fff',
                borderColor: '#fff',
                fontSize: '0.75rem',
              }}
            >
              {translate('errorReport.reportButton')}
            </Button>
          )}
        </div>
      </div>
    </Snackbar>
  );
}

export default GlobalSnackbar;
